import { getPrompt } from "features/ai/prompts/AI_prompt";
import { getAllMapsParams } from "features/comments/helpers";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { allInsightTypes, getAllTouchpoints, getInteractionSelector } from "redux/memoizedSelectors";
import { encode } from "utils/helpers";
import { v4 as uuid } from "uuid";
import { createInsight, linkInsightRecords, linkInteraction } from "../../../../redux/index";

type DropdownAIProps = {
    aiParameters?: any;
    closeDropdown?: () => void;
    link?: (id: string) => void;
};

type ItemAIProps = {
    title: string;
    description: string;
    relatedTouchpoint?: string;
    type?: string;
};



export const useAIParams = ({ aiParameters, closeDropdown, link }: DropdownAIProps) => {
    const { personaIdStr } = getAllMapsParams(useLocation().search);

    const { t } = useTranslation();
    const [showAI, setShowAI] = useState(false);
    const allTouchpoints = useSelector(getAllTouchpoints)
    const insightsTypes = useSelector(allInsightTypes)
    const interactions: any[] = useSelector(getInteractionSelector(personaIdStr,aiParameters?.stageId));


    if (!aiParameters) return {};

    const { stageName, swimlaneKey, stageId } = aiParameters || {};

    const handleRelations = (item: ItemAIProps, data: any) => {
        const { relatedTouchpoint } = item || {}; // new opportunity generated by ai
        const { id } = data || {};
        if (link) link(id);

        // Link related Touchpoints
        if (relatedTouchpoint) {
            const touchpointId = allTouchpoints.find((t: any) => t.name.toLowerCase() === relatedTouchpoint.toLowerCase())?.id;
            if (touchpointId) {
                // this is regular link on opportunity record to touchpoint
                linkInsightRecords({ itemId: id, recIds: [touchpointId], recEntityName: 'cem_touchpoints', attribute: 'linkedTouchpoints' })

                // this is link on persona interaction  record to opportunity
                if (interactions?.length > 0) {
                    const personaInteraction = interactions.find((inter: any) => inter?.touchPointId === touchpointId);
                    if (personaInteraction)
                        linkInteraction({
                            recIds: [id],
                            stageId,
                            itemId: personaInteraction.id,
                            attribute: "linkedActions",
                            recEntityName: "cem_cxactiontask",
                        } as any);
                }
            }
        }

    };
    const handleCreateAIItems = (items: ItemAIProps[]) => {

        items.forEach((item: ItemAIProps) => {

            const { title, description, type } = item || {}; // new opportunity generated by ai
            const insightTypeId = insightsTypes.find((t: any) => t.name.trim().toLowerCase() === type?.trim()?.toLowerCase())?.id;
            createInsight({
                item: {
                    id: uuid(),
                    name: encode(title),
                    typeId: insightTypeId,
                    description: encode(description),
                },
                onSuccess: (data: any) => handleRelations(item, data),
            } as any);
        });
    };
    const handleOpen = () => {
        if (!stageName) return toast.info(t("STAGE_NAME_REQUIRED"));
        return setShowAI(true);
    };
    const handleClose = (all?: boolean) => {
        setShowAI(false);
        if (all && closeDropdown) closeDropdown();
    };

    const aiParams = {
        show: showAI,
        openAI: handleOpen,
        ComponentParams: {
            onClose: handleClose,
            getPrompt: getPrompt.CJM_INSIGHT,
            onSave: handleCreateAIItems,
            stageId,
            swimlaneKey,
        },
    };

    return { aiParams: aiParams };
};
